export default __webpack_public_path__ + "static/media/ic_guyana.f810210e.svg";